import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import GreenButton from './GreenButton';
import styles from 'styles/components/BottomButtons.module.scss';

const BottomButton = ({ buttonText, handleClick }) => (
  <div className={clsx(styles.buttonsContainer, styles.sticky, styles.oneButton)}>
    <GreenButton buttonText={buttonText} handleClick={handleClick} />
  </div>
);

BottomButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
};

BottomButton.defaultProps = {
  handleClick: () => {},
};

export default BottomButton;
